import { render, staticRenderFns } from "./CatalogForm.vue?vue&type=template&id=5c72a7a5&scoped=true"
import script from "./CatalogForm.vue?vue&type=script&lang=js"
export * from "./CatalogForm.vue?vue&type=script&lang=js"
import style0 from "./CatalogForm.vue?vue&type=style&index=0&id=5c72a7a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72a7a5",
  null
  
)

export default component.exports